module.exports = __webpack_public_path__ + "static/media/notification-icon-giztix.9c4a7ae6.svg";